import { Container, Row, Col }from 'react-bootstrap';
import { useState, useEffect } from 'react';



interface ContentProps{
    title: string;
    isoDatatime: string; /* iso format string */

}

function CountDownBox({title, isoDatatime}: ContentProps){
    const dateObj = new Date(isoDatatime);
    const TIME_TO_EMPHASIZE = 7;
    const [remainingWeeks, setRemainingWeeks] = useState(0);
    const [remainingDays, setRemainingDays] = useState(0);
    const [remainingHours, setRemainingHours] = useState(0);
    const [remainingMinutes, setRemainingMinutes] = useState(0);
    const [remainingSeconds, setRemainingSeconds] = useState(0);
    const [collapsed, setCollapsed] = useState(false);


    const updateTimer = () => {
        const now = new Date()
        let diff = +dateObj - +now;
        
    
        console.log(dateObj)
        console.log(now)
        console.log(diff)

        // Calculate time units
        const weeks = Math.floor(diff % (1000 * 60 * 60 * 24 * 7 * 52) / (1000 * 60 * 60 * 24 * 7));
        const d = Math.floor((diff % (1000 * 60 * 60 * 24 * 7)) / (1000 * 60 * 60 * 24));
        const h = Math.floor((diff / (1000 * 60 * 60)) % (24));
        const m = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
        const s = Math.floor((diff % (1000 * 60)) / 1000);

        console.log(`${d}d ${h}h ${m}m ${s}s`);
        setRemainingWeeks(weeks)
        setRemainingDays(d)
        setRemainingHours(h)
        setRemainingMinutes(m)
        setRemainingSeconds(s)
        /*
        if (diff < 0) {
            clearInterval(timer);
            console.log("Finished");
        }*/

    }

    const isFinalCountdown = (): boolean => {
        return ((remainingWeeks < 1) && (remainingDays < 1)) ? true : false
    }
    const bottomLineFont = (): string =>{
        return (isFinalCountdown()) ? "font-size-tiny" : "font-size-xt"
    }
    const formatNumber = (value: number): string =>{
        return value.toString().padStart(2, '0');
    }
    
    useEffect(() => {
        // 2. Set up the interval to update state every 1000ms (1 second)
        const timerId = setInterval(() => {
            updateTimer();
        }, 1000);
        
       

        // 3. Return a cleanup function to clear the interval on unmount
        return () => {
        clearInterval(timerId);
        };
    }, []);

    return (
        <> 
            <Container fluid className="color-bg-primary font-body border my-1" >
                <Row className="justify-content-start color-bg-secondary color-font-primary font-size-xl">
                    <Col>{title}</Col>
                </Row>
                { (!collapsed) &&
                    <Row className="justify-content-start">
                        { (remainingWeeks > 0) &&
                            <Col>
                                <div className="d-inline-block text-start"><p className="font-size-xxl">{remainingWeeks}</p></div>
                                <div className="d-inline-block text-start font-size-small">
                                    <div>Week{(remainingWeeks > 1) && "s"}</div>
                                    <div className="px-1 color-bg-secondary color-font-primary">To Go</div>
                                </div>
                            </Col>
                        }
                        { (remainingDays > 0) &&
                        <Col>
                            <div className="d-inline-block text-start"><p className="font-size-xxl">{remainingDays}</p></div>
                            <div className="d-inline-block text-start font-size-small">
                                <div>Day{(remainingDays > 1) && "s"}</div>
                                <div className="px-1 color-bg-secondary color-font-primary">To Go</div>
                            </div>
                        </Col>
                        }
                    </Row>
                }
                <Row className={ isFinalCountdown() ? "justify-content-start font-size-xxl" : "justify-content-start font-size-large"}>
                    <Col className="px-0 border">
                        { (collapsed) &&
                            <>
                                <div className="d-inline-block px-1">{remainingWeeks}<sup>week{(remainingWeeks > 1) && "s"}</sup></div>
                                <div className="d-inline-block px-1">{remainingDays}<sup>day{(remainingDays > 1) && "s"}</sup></div>
                            </>
                        }
                        <div className="d-inline-block">
                            <div>{formatNumber(remainingHours)}:</div>
                            { isFinalCountdown() && <div className={bottomLineFont()}>hours</div>}
                        </div>
                        <div className="d-inline-block">
                            <div>{formatNumber(remainingMinutes)}</div>
                            { isFinalCountdown() && <div className={bottomLineFont()}>minutes</div>}
                        </div>
                        <div className="d-inline-block">
                            <div><sup>:{formatNumber(remainingSeconds)}</sup></div>
                            { isFinalCountdown() && <div className={bottomLineFont()}>seconds</div>}
                        </div>
                    </Col>
                </Row>
            </Container>
        </>
    )
}

export default CountDownBox;